/**
 * Creates a sequencer function that ensures async tasks are executed sequentially.
 * Each task will only start after the previous one in its sequence has completed or failed.
 */
export default function createExecuteSequentially() {
  let taskChain = Promise.resolve();

  /**
   * Ensures that async tasks are executed sequentially for this specific sequencer instance.
   * @param taskAsyncFunction A function that returns a promise.
   * @param logger object with an error method.
   * @returns The promise returned by taskAsyncFunction.
   */
  return function executeSequentially(taskAsyncFunction, logger) {
    const currentTaskPromise = taskChain
      .catch((err) => {
        if (logger && logger.error) {
          logger.error('A previous task in the sequence failed:', err);
        }
        // We still want to proceed to the next task, so we don't re-throw here.
        return Promise.resolve();
      })
      .then(() => taskAsyncFunction());

    // The next task in the sequence will chain
    // off the actual result of currentTaskPromise.
    // This allows its .catch() block (for logging)
    // to see any error from currentTaskPromise.
    taskChain = currentTaskPromise;

    return currentTaskPromise;
  };
}
